import { render, staticRenderFns } from "./icon-select.vue?vue&type=template&id=abab7f2c&scoped=true"
import script from "./icon-select.vue?vue&type=script&lang=ts"
export * from "./icon-select.vue?vue&type=script&lang=ts"
import style0 from "./icon-select.vue?vue&type=style&index=0&id=abab7f2c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abab7f2c",
  null
  
)

export default component.exports